const carriers: Array<{
  name: string;
  pattern: RegExp;
  urlTemplate: (tn: string) => string;
}> = [
  // UPS - 1Z followed by 16 alphanumeric characters
  {
    name: 'UPS',
    pattern: /^1Z[A-Z0-9]{16}$/i,
    urlTemplate: (tn) => `https://www.ups.com/track?tracknum=${tn}`,
  },

  // FedEx - 12, 15, 20, or 22 digits
  {
    name: 'FedEx',
    pattern: /^(\d{12}|\d{15}|\d{20}|\d{22})$/,
    urlTemplate: (tn) => `https://www.fedex.com/fedextrack/?trknbr=${tn}`,
  },

  // DHL - 10 or 11 digits
  {
    name: 'DHL',
    pattern: /^\d{10,11}$/,
    urlTemplate: (tn) =>
      `https://www.dhl.com/en/express/tracking.html?AWB=${tn}`,
  },

  // USPS - Various formats
  // 20 digits, 22 digits starting with 9, 26 digits, 13 chars starting with 2 letters
  {
    name: 'USPS',
    pattern: /^(\d{20}|9\d{21}|9\d{25}|[A-Z]{2}\d{9}US)$/i,
    urlTemplate: (tn) =>
      `https://tools.usps.com/go/TrackConfirmAction?tLabels=${tn}`,
  },

  // Amazon Logistics - TBA followed by 12-13 digits
  {
    name: 'Amazon',
    pattern: /^TBA\d{12,13}$/i,
    urlTemplate: (tn) => `https://track.amazon.com/tracking/${tn}`,
  },

  // OnTrac - C followed by 14 digits
  {
    name: 'OnTrac',
    pattern: /^C\d{14}$/i,
    urlTemplate: (tn) => `https://www.ontrac.com/tracking/?number=${tn}`,
  },

  // LaserShip - 1LS followed by 12 digits, or L followed by 8-9 digits
  {
    name: 'LaserShip',
    pattern: /^(1LS\d{12}|L[A-Z]\d{8})$/i,
    urlTemplate: (tn) => `https://www.lasership.com/track/${tn}`,
  },

  // Canada Post - 16 characters
  {
    name: 'Canada Post',
    pattern: /^\d{16}$/,
    urlTemplate: (tn) =>
      `https://www.canadapost-postecanada.ca/track-reperage/en#/search?searchFor=${tn}`,
  },
];

export function getTrackingUrl(trackingNumber: string): string | null {
  // Remove whitespace and hyphens for easier matching
  const cleaned = trackingNumber.trim().replace(/[\s-]/g, '');

  // Try to match against each carrier's pattern
  for (const carrier of carriers) {
    if (carrier.pattern.test(cleaned)) {
      return carrier.urlTemplate(cleaned);
    }
  }

  return null;
}
